module.exports = __webpack_public_path__ + "static/media/support-illustration.d4824337.png";